import MobileDetect from 'mobile-detect';

export const isMobileAgent =
  typeof window !== 'undefined' ? !!new MobileDetect(window.navigator.userAgent).mobile() : false;
